/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService
 */

export let ComHubspotAiContextMiningModelsAbstractSdcAnalysisError;
(function (_ComHubspotAiContextMiningModelsAbstractSdcAnalysisError) {})(ComHubspotAiContextMiningModelsAbstractSdcAnalysisError || (ComHubspotAiContextMiningModelsAbstractSdcAnalysisError = {}));
export let ComHubspotAiContextMiningModelsAbstractSmartDataCaptureCitationError;
(function (_ComHubspotAiContextMiningModelsAbstractSmartDataCaptureCitationError) {})(ComHubspotAiContextMiningModelsAbstractSmartDataCaptureCitationError || (ComHubspotAiContextMiningModelsAbstractSmartDataCaptureCitationError = {}));
export let ComHubspotAiContextMiningModelsAbstractTranscriptAnalysisError;
(function (_ComHubspotAiContextMiningModelsAbstractTranscriptAnalysisError) {})(ComHubspotAiContextMiningModelsAbstractTranscriptAnalysisError || (ComHubspotAiContextMiningModelsAbstractTranscriptAnalysisError = {}));
export const getPropertySuggestionsForSourceRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'getPropertySuggestionsForSource',
  auth: 'app',
  fingerprint: 'bUdjT7L7JS9xHFYckncHsPRhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPropertySuggestionsForSourceBatchRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'getPropertySuggestionsForSourceBatch',
  auth: 'app',
  fingerprint: '5V-aemc24Yan4KTmaoZLrPRhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setUserDecisionV2Rpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'setUserDecisionV2',
  auth: 'app',
  fingerprint: 'mPUicEQI-ZLQFdQq1kxzJ_RhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const triggerTranscriptAnalysisRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'triggerTranscriptAnalysis',
  auth: 'app',
  fingerprint: '0AmcWKxnLDiA0VcvA6jCcPRhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPropertySuggestionsForRecordRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'getPropertySuggestionsForRecord',
  auth: 'app',
  fingerprint: 'oHBu-QAEQCpBT9B7WZ4rA_RhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPendingSuggestionsForRecordRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'getPendingSuggestionsForRecord',
  auth: 'app',
  fingerprint: '1hrNlEQej7kzD4jMkWOE6_RhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPropertySuggestionsForPortalRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'getPropertySuggestionsForPortal',
  auth: 'app',
  fingerprint: 'XmVEkQGTISqraTATQlIFkvRhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPropertySuggestionsForPortalPaginatedRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'getPropertySuggestionsForPortalPaginated',
  auth: 'app',
  fingerprint: 'XAL6vzJpm3N_EBHhjUVBLvRhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPropertySuggestionsForPortalByObjectPaginatedRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'getPropertySuggestionsForPortalByObjectPaginated',
  auth: 'app',
  fingerprint: 'GdrSO70LwBcylztgKri6h_RhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPropertySuggestionsCountRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'getPropertySuggestionsCount',
  auth: 'app',
  fingerprint: 'oDOInkHuHb5-S2vaoBmBzfRhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSmartDataCaptureCitationRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'getSmartDataCaptureCitation',
  auth: 'app',
  fingerprint: 'aU8H37Pk1dHqCPefjDrUSrSbSWM9umzZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setUserReviewSourceRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'setUserReviewSource',
  auth: 'app',
  fingerprint: 'KPAUUguG1Sv_75IFOPU9yvRhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const recordSuggestionViewsRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'recordSuggestionViews',
  auth: 'app',
  fingerprint: 'BxDWlItMQZyTS37CMbaUYfRhOJJ4Kq88',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateSuggestionMetadataRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'updateSuggestionMetadata',
  auth: 'app',
  fingerprint: '74IE98JG7aA9EuGzVMd7-CxjXDehcxyu',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const triggerPreviewAnalysisRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'triggerPreviewAnalysis',
  auth: 'app',
  fingerprint: 'KbtWwAYly5O7C8EMqS_icCxjXDehcxyu',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPreviewGenerationRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'getPreviewGeneration',
  auth: 'app',
  fingerprint: 'YrL5PlhkCM7Tg8rqsdthVixjXDehcxyu',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRunPropertiesRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'getRunProperties',
  auth: 'app',
  fingerprint: '-_Nqiy64jfZLKlIQpbv_6yxjXDehcxyu',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchSdcSuggestionsRpc = {
  serviceName: 'com.hubspot.ai.context.mining.rpc.TranscriptPropertyUpdateSuggestionsService',
  rpcName: 'searchSdcSuggestions',
  auth: 'app',
  fingerprint: 'QlW132l1gcEfNCU5JwcqmSxjXDehcxyu',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};